import { Injectable } from '@angular/core';

import type { RootState } from '../../../background-service-worker/services/extension-store/extension.store';
import { GBMessages } from '../../../background-service-worker/services/message-handler/message-handler.interfaces';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  public loadState = (): Promise<RootState> => chrome.runtime.sendMessage(GBMessages.GET_EXTENSION_STATE);
}
